import { render, staticRenderFns } from "./root.vue?vue&type=template&id=77df5e83&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"
import style0 from "./root.vue?vue&type=style&index=0&id=77df5e83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77df5e83",
  null
  
)

export default component.exports